import {Spinner} from "@heroui/react";
import {twMerge} from 'tailwind-merge';

export default function PageLoader({isLoading = true, ...props}) {
	return (
		isLoading &&
		<div className={twMerge([
			"flex justify-center items-center h-[inherit] w-[inherit]",
			"bottom-0 left-0 z-50",
			props?.className
		])}>
			<Spinner size="lg" {...props}/>
			{/*<img src="/images/logo-icon.png" className="animate-pulse max-w-28" alt="logo"/>*/}
		</div>
	);
}
